var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCoins(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 9.70839C10.9488 9.70839 12.7984 9.36081 14.227 8.72593C14.6253 8.54884 15.0154 8.33861 15.375 8.08984V9.00005C15.375 10.5648 12.5208 11.8334 9 11.8334C5.47919 11.8334 2.625 10.5648 2.625 9.00005V8.08984C2.98455 8.33861 3.37467 8.54884 3.77299 8.72593C5.20162 9.36081 7.05113 9.70839 9 9.70839Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.227 12.6217C14.6253 12.4446 15.0154 12.2344 15.375 11.9856V12.8958C15.375 14.4606 12.5208 15.7291 9 15.7291C5.47919 15.7291 2.625 14.4606 2.625 12.8958V11.9856C2.98455 12.2344 3.37467 12.4446 3.77299 12.6217C5.20162 13.2566 7.05113 13.6041 9 13.6041C10.9488 13.6041 12.7984 13.2566 14.227 12.6217Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.375 5.10409C15.375 6.66889 12.5208 7.93742 9 7.93742C5.47919 7.93742 2.625 6.66889 2.625 5.10409C2.625 3.53928 5.47919 2.27075 9 2.27075C12.5208 2.27075 15.375 3.53928 15.375 5.10409Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoins);
export default __webpack_public_path__ + "static/media/coins.759d327470626e235b53be030a7d5a62.svg";
export { ForwardRef as ReactComponent };